import {
  apiAdminworkspaceConfigsIdPatch,
  apiAdminworkspaceConfigsPost
} from '@r/api/generated/client.ts';

type SavePurchaseProofSettingInput = {
  enabled: boolean;
  configDefinitionId?: number;
  workspaceConfigId?: number;
};

type SaveBooleanSettingInput = SavePurchaseProofSettingInput & {
  missingConfigError: Error;
};

/** Indicates that the purchase-proof config definition is unavailable. */
export class MissingPurchaseProofConfigError extends Error {
  constructor() {
    super('Missing core:enable-purchase-proof config definition');
    this.name = 'MissingPurchaseProofConfigError';
  }
}

/** Indicates that the waiting-list config definition is unavailable. */
export class MissingWaitingListConfigError extends Error {
  constructor() {
    super('Missing core:accept-waiting-list config definition');
    this.name = 'MissingWaitingListConfigError';
  }
}

/** Persists a boolean workspace setting by updating it or creating it when absent. */
async function saveBooleanSetting({
  enabled,
  configDefinitionId,
  workspaceConfigId,
  missingConfigError
}: SaveBooleanSettingInput) {
  const value = String(enabled);

  if (workspaceConfigId) {
    return apiAdminworkspaceConfigsIdPatch(String(workspaceConfigId), { value });
  }

  if (!configDefinitionId) {
    throw missingConfigError;
  }

  return apiAdminworkspaceConfigsPost({
    value,
    config: `/configs/${configDefinitionId}`
  });
}

/** Persists the purchase-proof feature setting for the current workspace. */
export function savePurchaseProofSetting(input: SavePurchaseProofSettingInput) {
  return saveBooleanSetting({
    ...input,
    missingConfigError: new MissingPurchaseProofConfigError()
  });
}

/** Persists the waiting-list feature setting for the current workspace. */
export function saveWaitingListSetting(input: SavePurchaseProofSettingInput) {
  return saveBooleanSetting({
    ...input,
    missingConfigError: new MissingWaitingListConfigError()
  });
}
